module.exports = __webpack_public_path__ + "static/media/search.c3671f16.svg";